import * as $ from 'jquery';

export const additionalInformationElementStorage = {};
